import { z } from 'zod'

export const managerBenefitGetCorporateMileageSchema = z.object({
  /** 哩程數 */
  mileage: z.number(),
  /** 上限哩程數 */
  maxMileage: z.number()
})

export interface ManagerBenefitGetCorporateMileage
  extends z.infer<typeof managerBenefitGetCorporateMileageSchema> {}

export class ManagerBenefitGetCorporateMileage {
  constructor() {
    return {
      mileage: 0,
      maxMileage: 0
    }
  }
}
